
import {
    NetIncomeCalculatorConfig,
    FederalState,
    ChurchTaxRates,
} from '@fxxl/types/net_income_calculator_types';

const churchTaxRates: ChurchTaxRates = {
    [FederalState.BW]: 8, [FederalState.BY]: 8,
    [FederalState.BE]: 9, [FederalState.BB]: 9, [FederalState.HB]: 9, [FederalState.HH]: 9, [FederalState.HE]: 9,
    [FederalState.MV]: 9, [FederalState.NI]: 9, [FederalState.NW]: 9, [FederalState.RP]: 9, [FederalState.SL]: 9,
    [FederalState.SN]: 9, [FederalState.ST]: 9, [FederalState.SH]: 9, [FederalState.TH]: 9,
};

export const NET_INCOME_CALCULATOR_CONFIG_2025: NetIncomeCalculatorConfig = Object.freeze({
    year: 2025,

    contributionAssessmentLimits: {
        pensionInsurance: 8050,
        unemploymentInsurance: 8050,
        healthAndCareInsurance: 5512.5,
    },

    contributionRates: {
        pensionInsurance: 18.6,
        unemploymentInsurance: 2.6,
        healthInsurance: 14.6,
        careInsurance: 3.6,
        careInsuranceSurcharge: 0.6,
    },

    taxAllowances: {
        basicAllowanceYear: 12096,
        childAllowanceYear: 6672,
        incomeRelatedExpensesLumpSumYear: 1230,
        specialExpensesLumpSumYear: 36,
    },

    churchTaxRates: churchTaxRates,

    solidaritySurchargeThresholds: {
        class1_2_4_5_6: 19950,
        class3: 39900,
    },

    // Simplified tax rate formula 2025 (Basic tariff)
    incomeTaxTariff: (annualTaxableIncome: number): number => {
        if (annualTaxableIncome <= 12096) {
            return 0;
        } else if (annualTaxableIncome <= 17443) {
            const y = (annualTaxableIncome - 12096) / 10000;
            return (932.3 * y + 1400) * y;
        } else if (annualTaxableIncome <= 68480) {
            const z = (annualTaxableIncome - 17443) / 10000;
            return (176.64 * z + 2397) * z + 1015.13;
        } else if (annualTaxableIncome <= 277825) {
            return 0.42 * annualTaxableIncome - 10911.92;
        } else {
            return 0.45 * annualTaxableIncome - 19246.67;
        }
    },
});